import {
  isBinanceFuture,
  isBybitFuture,
  isEmpty,
  isNull,
  isUSD,
  parseToFloat,
} from './Common';
import { getExchangeExEnum, getExchangeExStr } from './order';
import { isDev } from './fetcher';

export const KeyExchangeTable = {
  TOKEN: {
    K: 0,
    T: 'token',
  },
  AMOUNT: {
    K: 1,
    T: 'amount',
  },
  PRICE_USD: {
    K: 2,
    T: 'priceUSD',
  },
  TOTAL_USD: {
    K: 3,
    T: 'totalUSD',
  },
  POURCENTAGE: {
    K: 4,
    T: '%',
  },
  FREE: {
    K: 5,
    T: 'Free',
  },
  URL_CHARTS: {
    K: 6,
    T: 'charts1D',
  },
  URL_CHARTS7: {
    K: 7,
    T: 'charts7D',
  },
  POURC_24H: {
    K: 9,
    T: '% 24h',
  },
  POURC_7D: {
    K: 8,
    T: '% 7d',
  },
  VOL_24H: {
    K: 10,
    T: 'Vol 24h',
  },
  LOCKED: {
    K: 11,
    T: 'locked',
  },
  LOCKEDONWOT: {
    K: 12,
    T: 'lockedOnWot',
  },
  AVAILABLE: {
    K: 13,
    T: 'available',
  },
  DETAIL: {
    K: 14,
    T: 'detail',
  },
};

const concatExchangeTable = (r, t) => {
  for (const v of t) {
    // console.log(r, t, v);

    let m = r.find(
      (x) => x[KeyExchangeTable.TOKEN.K] === v[KeyExchangeTable.TOKEN.K],
    );
    if (v[KeyExchangeTable.TOKEN.K] === 'XBT') {
      m = r.find((x) => x[KeyExchangeTable.TOKEN.K] === 'BTC');
    }
    if (v[KeyExchangeTable.TOKEN.K].indexOf('.S')) {
      m = r.find(
        (x) =>
          x[KeyExchangeTable.TOKEN.K] ===
          v[KeyExchangeTable.TOKEN.K].replace('.S', ''),
      );
    }
    // console.log(m);
    if (m) {
      // meme token trouver
      m[KeyExchangeTable.AMOUNT.K] = parseQty(
        m[KeyExchangeTable.AMOUNT.K] + v[KeyExchangeTable.AMOUNT.K],
      );
      m[KeyExchangeTable.FREE.K] = parseQty(
        m[KeyExchangeTable.FREE.K] + v[KeyExchangeTable.FREE.K],
      );
      m[KeyExchangeTable.LOCKED.K] = parseQty(
        m[KeyExchangeTable.LOCKED.K] + v[KeyExchangeTable.LOCKED.K],
      );
      m[KeyExchangeTable.LOCKEDONWOT.K] = parseQty(
        m[KeyExchangeTable.LOCKEDONWOT.K] + v[KeyExchangeTable.LOCKEDONWOT.K],
      );
      m[KeyExchangeTable.TOTAL_USD.K] += v[KeyExchangeTable.TOTAL_USD.K];
      m[KeyExchangeTable.TOTAL_USD.K] = parseFloat(
        m[KeyExchangeTable.TOTAL_USD.K].toFixed(2),
      );
      m[KeyExchangeTable.DETAIL.K].push(v[KeyExchangeTable.DETAIL.K]);
    } else {
      r = [...r, v];
    }
  }
  return r;
};
export const getTableExchanges = (exchanges) => {
  let table = [];
  for (const exchange of exchanges) {
    const t = getTableEx(exchange);
    table = concatExchangeTable(table, t);
  }
  return addPourcentageAndSort(table);
};

export const getPourcentage = (part, sum) => {
  return parseToFloat((part / sum) * 100, 0.01);
};

const addPourcentageAndSort = (table) => {
  let sumUSD = 0;
  for (const t of table) {
    sumUSD += t[KeyExchangeTable.TOTAL_USD.K];
  }
  for (const t of table) {
    t[KeyExchangeTable.POURCENTAGE.K] = getPourcentage(
      t[KeyExchangeTable.TOTAL_USD.K],
      sumUSD,
    );
  }
  return table.sort(
    (a, b) => b[KeyExchangeTable.TOTAL_USD.K] - a[KeyExchangeTable.TOTAL_USD.K],
  );
};

export const parsePriceUSD = (priceUSD) => {
  if (priceUSD < 1) return priceUSD.toFixed(4);
  if (priceUSD < 10) return priceUSD.toFixed(3);
  if (priceUSD < 100) return priceUSD.toFixed(2);
  if (priceUSD < 1000) return priceUSD.toFixed(1);
  return priceUSD.toFixed(0);
  // return priceUSD;
};

export const getApiLength = (exchangeName) => {
  let apiKeyLength = null;
  let apiSecretLength = null;
  if (!isNull(exchangeName)) {
    if (exchangeName.indexOf('Binance') !== -1) {
      apiKeyLength = 64;
      apiSecretLength = 64;
    } else if (exchangeName === 'Bitfinex') {
      apiKeyLength = 43;
      apiSecretLength = 43;
    } else if (exchangeName === 'Bittrex') {
      apiKeyLength = 32;
      apiSecretLength = 32;
    } else if (exchangeName === 'Bitmex') {
      apiKeyLength = 24;
      apiSecretLength = 48;
    } else if (exchangeName === 'Kraken') {
      apiKeyLength = 56;
      apiSecretLength = 88;
    } else if (exchangeName.indexOf('FTX') !== -1) {
      apiKeyLength = 40;
      apiSecretLength = 40;
    } else if (exchangeName === 'Kucoin') {
      apiKeyLength = 24;
      apiSecretLength = 36;
    } else if (exchangeName === 'Okx') {
      apiKeyLength = 36;
      apiSecretLength = 32;
    } else if (exchangeName === 'Ascendex') {
      apiKeyLength = 32;
      apiSecretLength = 64;
    } else if (exchangeName === 'LBank') {
      apiKeyLength = 36;
      // apiSecretLength = 848;
    } else if (exchangeName === 'CryptoCom') {
      apiKeyLength = 22;
      apiSecretLength = 28;
    } else if (exchangeName.indexOf('Bybit') !== -1) {
      apiKeyLength = 18;
      apiSecretLength = 36;
    }
  }
  return {
    apiKey: apiKeyLength,
    apiSecret: apiSecretLength,
  };
};

export const parseQty = (qty) => {
  if (!qty) return 0;
  if (qty < 1) return parseToFloat(qty, 0.000001);
  if (qty < 10) return parseToFloat(qty, 0.00001);
  if (qty < 100) return parseToFloat(qty, 0.0001);
  if (qty < 1000) return parseToFloat(qty, 0.001);
  return parseToFloat(qty, 0.01);
};

const getTableEx = (exchange) => {
  const table = [];
  if (isNull(exchange) || isNull(exchange.Holds)) {
    return table;
  }
  try {
    let i = 0;
    for (const hold of exchange.Holds) {
      if (isNull(hold) || isNull(hold.Token)) continue;
      const token = hold.Token;
      const symbol = token.Symbol;
      const priceTokenUSD = isUSD(symbol) ? 1 : token.Price;
      const pourc24h = token.PercentChange24H;
      const pourc7d = token.PercentChange7D;
      const vol24h = token.Volume24H;

      const urlCharts = token.CMCId
        ? `https://s2.coinmarketcap.com/generated/sparklines/web/1d/usd/${token.CMCId}.png`
        : '';
      const urlCharts7 = token.CMCId
        ? `https://s2.coinmarketcap.com/generated/sparklines/web/7d/usd/${token.CMCId}.png`
        : '';
      const total = parseToFloat(priceTokenUSD * hold.Amount, 0.01, true);
      const amount = parseQty(hold.Amount);
      if (amount === 0) continue;
      table[i] = {
        [KeyExchangeTable.TOKEN.K]: symbol,
        [KeyExchangeTable.AMOUNT.K]: amount,
        [KeyExchangeTable.FREE.K]: parseQty(hold.Free),
        [KeyExchangeTable.PRICE_USD.K]: parseFloat(
          parsePriceUSD(priceTokenUSD),
        ),
        [KeyExchangeTable.TOTAL_USD.K]: total,
        [KeyExchangeTable.POURCENTAGE.K]: 0,
        [KeyExchangeTable.URL_CHARTS.K]: urlCharts,
        [KeyExchangeTable.URL_CHARTS7.K]: urlCharts7,
        [KeyExchangeTable.POURC_24H.K]: pourc24h,
        [KeyExchangeTable.POURC_7D.K]: pourc7d,
        [KeyExchangeTable.VOL_24H.K]: vol24h,
        [KeyExchangeTable.LOCKED.K]: hold.Locked,
        [KeyExchangeTable.LOCKEDONWOT.K]: hold.LockedOnWot,
        [KeyExchangeTable.DETAIL.K]: [],
      };
      table[i][KeyExchangeTable.DETAIL.K].push(
        `${amount} ${symbol}: ${exchange.Name}`,
      );
      ++i;
    }
  } catch (e) {
    console.error(e);
  }
  return table;
};

export const isBTC = (symbol) => {
  return symbol.toLowerCase() === 'btc' || symbol.toLowerCase() === 'xbt';
};

export const isALT = (symbol) => {
  return !isBTC(symbol) && !isStableCoin(symbol);
};

export const isHedgeMode = (options) => {
  return isNull(options)
    ? false
    : options.HedgeMode === 'true' || options.HedgeMode === 'True';
};

export const isStableCoin = (symbol) => {
  if (isEmpty(symbol)) return false;
  const symbolStr = symbol.toLowerCase();
  if (
    symbolStr.includes('usd') ||
    symbolStr.includes('eur') ||
    [
      'UST',
      'DAI',
      'PAX',
      'GBP',
      'CAD',
      'CHF',
      'JPY',
      'TRY',
      'AUD',
      'BIDR',
      'BRL',
      'RUB',
      'IDRT',
      'NGN',
      'UAH',
      'VAI',
      'BVND',
      'ZAR',
    ].includes(symbol)
  ) {
    return true;
  }
  return false;
};

// Ordre table: Currency, Total, Price $, Total $, %
export const getTableExchange = (exchange) => {
  let table = [];
  try {
    if (exchange) {
      table = Array.isArray(exchange)
        ? getTableExchanges(exchange)
        : getTableEx(exchange);
    }
  } catch (e) {
    console.error(e);
  }
  return addPourcentageAndSort(table);
};

const getTotalUSDExchange = (exchange, filter = null) => {
  let sumUSD = 0;
  const table = getTableExchange(exchange);
  if (table) {
    for (const t of table) {
      if (filter === null || filter(t[KeyExchangeTable.TOKEN.K])) {
        sumUSD += t[KeyExchangeTable.TOTAL_USD.K];
      }
    }
  }
  return sumUSD;
};

export const getTotalUSD = (exchanges, filter = null) => {
  if (!exchanges) return 0;

  let sumUSD = 0;
  if (Array.isArray(exchanges)) {
    for (const exchange of exchanges) {
      sumUSD += getTotalUSDExchange(exchange, filter);
    }
  } else {
    sumUSD += getTotalUSDExchange(exchanges, filter);
  }
  return parseToFloat(sumUSD, 0.1, true);
};

export const getTotalCapital = (exchanges) => {
  if (!exchanges) return '';
  let sum = 0;
  if (Array.isArray(exchanges)) {
    for (const exchange of exchanges) {
      sum += exchange.Capital;
    }
  } else {
    sum += exchanges.Capital;
  }
  return sum.toFixed(0);
};

export const getPairInfo = (pair, availableAmounts, exchangeName) => {
  if (!availableAmounts || availableAmounts.length === 0) return null;
  const exchangeStr = getExchangeExStr(exchangeName);
  const exchange = availableAmounts.find((x) => x.ExchangeName === exchangeStr);
  const price = exchange.Pairs.find((x) => x.Pair === pair);
  return price;
};

export const getPricePair = (
  pair,
  availableAmounts,
  exchangeName = 'Binance_Spot',
) => {
  if (!availableAmounts || availableAmounts.length === 0) return '';
  const binance = availableAmounts.find((x) => x.ExchangeName === exchangeName);
  const firstExchange = binance || availableAmounts[0];
  if (!firstExchange.PairsPrice || firstExchange.PairsPrice.length === 0)
    return '';
  const price = firstExchange.PairsPrice.find((x) => x.Pair === pair);
  if (!price) return '';
  return price.Last;
};

export const getExchangeSelect = (exchange) => {
  return { value: exchange, label: exchange, exchange };
};

export const isReferral = (exchange) => {
  const isReferral = exchange && exchange.IsReferral;
  const isPaperWallet = exchange && exchange.IsPaperTrading;

  return !isPaperWallet && isReferral;
};

const optionsExchanges = [
  // { value: 'Binance_Test', label: 'Binance_Test', exchange: 'Binance_Test' },
  { value: 'Binance_Spot', label: 'Binance_Spot', exchange: 'Binance_Spot' },
  {
    value: 'Binance_Futures',
    label: 'Binance_Futures',
    exchange: 'Binance_Futures',
  },
  // { value: 'FTX', label: 'FTX', exchange: 'FTX' },
  // { value: 'FTX_US', label: 'FTX_US', exchange: 'FTX_US' },
  { value: 'Kucoin', label: 'Kucoin', exchange: 'Kucoin' },
  { value: 'Kraken', label: 'Kraken', exchange: 'Kraken' },
  // { value: 'Bitmex', label: 'Bitmex', exchange: 'Bitmex' },
  // { value: 'Bittrex', label: 'Bittrex', exchange: 'Bittrex' },
  { value: 'Huobi', label: 'Huobi', exchange: 'Huobi' },
  { value: 'Bitfinex', label: 'Bitfinex', exchange: 'Bitfinex' },
  { value: 'Binance_US', label: 'Binance_US', exchange: 'Binance_US' },
  {
    value: 'Binance_Margin',
    label: 'Binance_Margin',
    exchange: 'Binance_Margin',
  },
  { value: 'Okx', label: 'Okx', exchange: 'Okx' },
  { value: 'Ascendex', label: 'Ascendex', exchange: 'Ascendex' },
  { value: 'LBank', label: 'LBank', exchange: 'LBank' },
  { value: 'CryptoCom', label: 'CryptoCom', exchange: 'CryptoCom' },
  { value: 'Bybit', label: 'Bybit', exchange: 'Bybit' },
  { value: 'Bybit_Futures', label: 'Bybit_Futures', exchange: 'Bybit_Futures' },
];

if (isDev()) {
  optionsExchanges.unshift({
    value: 'Binance_Test',
    label: 'Binance_Test',
    exchange: 'Binance_Test',
  });
  optionsExchanges.unshift({
    value: 'Binance_Futures_Test',
    label: 'Binance_Futures_Test',
    exchange: 'Binance_Futures_Test',
  });
  optionsExchanges.push({
    value: 'Bybit_Test',
    label: 'Bybit_Test',
    exchange: 'Bybit_Test',
  });
  optionsExchanges.push({
    value: 'Bybit_Futures_Test',
    label: 'Bybit_Futures_Test',
    exchange: 'Bybit_Futures_Test',
  });
}

// const nameNewExchanges = [
//   { value: 'Ascendex', label: 'Ascendex', exchange: 'Ascendex' },
//   { value: 'BitFlyer', label: 'BitFlyer', exchange: 'BitFlyer' },
//   { value: 'Bitget', label: 'Bitget', exchange: 'Bitget' },
//   { value: 'Bitmart', label: 'Bitmart', exchange: 'Bitmart' },
//   { value: 'Bitmex', label: 'Bitmex', exchange: 'Bitmex' },
//   { value: 'Bitso', label: 'Bitso', exchange: 'Bitso' },
//   { value: 'Bitstamp', label: 'Bitstamp', exchange: 'Bitstamp' },
//   { value: 'Bitvavo', label: 'Bitvavo', exchange: 'Bitvavo' },
//   { value: 'Blockchain', label: 'Blockchain', exchange: 'Blockchain' },
//   { value: 'Btcmarkets', label: 'Btcmarkets', exchange: 'Btcmarkets' },
//   { value: 'Cdax', label: 'Cdax', exchange: 'Cdax' },
//   { value: 'Cex', label: 'Cex', exchange: 'Cex' },
//   { value: 'Coinbase', label: 'Coinbase', exchange: 'Coinbase' },
//   { value: 'Coincheck', label: 'Coincheck', exchange: 'Coincheck' },
//   { value: 'Coinex', label: 'Coinex', exchange: 'Coinex' },
//   { value: 'Coinone', label: 'Coinone', exchange: 'Coinone' },
//   { value: 'Cryptocom', label: 'Cryptocom', exchange: 'Cryptocom' },
//   { value: 'Currency', label: 'Currency', exchange: 'Currency' },
//   { value: 'Delta', label: 'Delta', exchange: 'Delta' },
//   { value: 'Deribit', label: 'Deribit', exchange: 'Deribit' },
//   { value: 'Exmo', label: 'Exmo', exchange: 'Exmo' },
//   { value: 'Gate', label: 'Gate', exchange: 'Gate' },
//   { value: 'Gemini', label: 'Gemini', exchange: 'Gemini' },
//   { value: 'Hitbtc', label: 'Hitbtc', exchange: 'Hitbtc' },
//   { value: 'Idex', label: 'Idex', exchange: 'Idex' },
//   { value: 'Lbank', label: 'Lbank', exchange: 'Lbank' },
//   { value: 'Liquid', label: 'Liquid', exchange: 'Liquid' },
//   {
//     value: 'Mercadobitcoin',
//     label: 'Mercadobitcoin',
//     exchange: 'Mercadobitcoin',
//   },
//   { value: 'Mexc', label: 'Mexc', exchange: 'Mexc' },
//   { value: 'Okcoin', label: 'Okcoin', exchange: 'Okcoin' },
//   { value: 'Okx', label: 'Okx', exchange: 'Okx' },
//   { value: 'Paymium', label: 'Paymium', exchange: 'Paymium' },
//   { value: 'Phemex', label: 'Phemex', exchange: 'Phemex' },
//   { value: 'Poloniex', label: 'Poloniex', exchange: 'Poloniex' },
//   { value: 'Procoinbase', label: 'Procoinbase', exchange: 'Procoinbase' },
//   { value: 'Upbit', label: 'Upbit', exchange: 'Upbit' },
//   { value: 'Whitebit', label: 'Whitebit', exchange: 'Whitebit' },
//   { value: 'Woo', label: 'Woo', exchange: 'Woo' },
//   { value: 'Zbex', label: 'Zbex', exchange: 'Zbex' },
// ];

for (const ex of optionsExchanges) {
  ex.value = getExchangeExEnum(ex.value);
}
export { optionsExchanges };

export const formatDataForPost = (exchangeUser) => {
  if (exchangeUser.capitalRadio === 'Auto' && !exchangeUser.isPaperTrading)
    exchangeUser.capital = null;
  if (exchangeUser.isPaperTrading) {
    exchangeUser.apiKey = null;
    exchangeUser.apiSecret = null;
  }
  const exchange =
    exchangeUser &&
    exchangeUser.exchangeName &&
    exchangeUser.exchangeName.exchange
      ? exchangeUser.exchangeName.exchange
      : '';
  if (exchange === 'Kucoin' || exchange === 'Okx') {
    exchangeUser.option = `{ PassPhrase: "${exchangeUser.passPhrase}" }`;
  } else if (
    exchange.indexOf('FTX') !== -1 &&
    !isNull(exchangeUser.subAccount)
  ) {
    exchangeUser.option = `{ SubAccount: "${exchangeUser.subAccount}" }`;
  } else if (
    (isBinanceFuture(exchange) || isBybitFuture(exchange)) &&
    !exchangeUser.isPaperTrading
  ) {
    const hedgeMode = isNull(exchangeUser.hedgeMode)
      ? 'false'
      : exchangeUser.hedgeMode;
    exchangeUser.option = `{ HedgeMode: "${hedgeMode}" }`;
  }
  return exchangeUser;
};
